import { createTheme } from '@one-thd/sui-atomic-components';

const BlackFriday2026PrimaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

BlackFriday2026PrimaryOne.palette['--sui-palette-background-primary'] = '20 20 20';

export { BlackFriday2026PrimaryOne };